<ng-template #hightlight let-device="device">
    <div class="sir-highlights" [ngClass]="device === 'mobile' ? 'sir-highlights--mobile' : 'sir-highlights--desktop'">
        @for (element of highlightedItems; track $index) {
            <sirius-highlighted-item [label]="element.label" [value]="element.value" [icon]="element.icon.icon">
            </sirius-highlighted-item>
        }
    </div>
</ng-template>

<sirius-grid>
    <div class="sir-media">
        <sirius-image-item
            [image]="image | cast"
            [imageData]="imageData"
            [autocrop]="false"
            [fetchPriority]="'high'"
            data-cy="product-header-image">
        </sirius-image-item>
    </div>
    <div class="sir-content">
        <div class="sir-brand">
            @if (logo) {
                <img class="sir-logo" [src]="logo.url" data-cy="product-header-logo" alt="Universal Robots" />
            }
            <sirius-heading
                [text]="title"
                [textStyleCategory]="headingType"
                data-cy="product-header-title"
                textStyleSize="l">
            </sirius-heading>
        </div>
        @if (infoBubble) {
            <sirius-info-bubble [textHtml]="infoBubble.textHtml" data-cy="product-header-info-bubble">
            </sirius-info-bubble>
        }
        <div class="sir-details">
            <div class="sir-text">
                <sirius-heading
                    [text]="subTitle"
                    [h]="4"
                    textStyleSize="xs"
                    data-cy="product-header-subtitle"></sirius-heading>
                <sirius-text-html
                    [html]="textHtml"
                    data-cy="product-header-paragraph"></sirius-text-html>
                @if (externalLink) {
                    <a
                        class="sir-external-link"
                        data-cy="product-header-external-link"
                        siriusButton
                        [siriusLink]="externalLink"
                        [buttonText]="externalLink.title"
                        [buttonType]="'primary'"
                        [size]="'small'"
                        [iconName]="'sign_out'"
                        [iconPos]="'right'">
                    </a>
                }
            </div>
            @if (highlightedItems?.length) {
                <ng-container [ngTemplateOutlet]="hightlight" [ngTemplateOutletContext]="{ device: 'desktop' }">
                </ng-container>
            }
        </div>
        <div class="sir-buttons">
            <div class="sir-cta">
                @if (buttonPrimary) {
                    <a
                        siriusButton
                        [siriusLink]="buttonPrimary.link"
                        [iconName]="buttonPrimary.iconName"
                        [buttonText]="buttonPrimary.link.title"
                        [buttonType]="'primary'"
                        data-cy="product-header-primary-button">
                    </a>
                }
                @if (buttonSecondary) {
                    <a
                        siriusButton
                        [siriusLink]="buttonSecondary.link"
                        [iconName]="buttonSecondary.iconName"
                        [buttonText]="buttonSecondary.link.title"
                        [buttonType]="'secondary'"
                        data-cy="product-header-secondary-button">
                    </a>
                }
            </div>
        </div>
    </div>

    @if (highlightedItems?.length) {
        <ng-container [ngTemplateOutlet]="hightlight" [ngTemplateOutletContext]="{ device: 'mobile' }"> </ng-container>
    }
</sirius-grid>
